import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Rentals from './components/Rentals';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import SEO from './components/SEO';
import SchemaOrg from './components/SchemaOrg';
import { initGA, usePageTracking } from './utils/analytics';

// Admin Components
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import MediaLibrary from './pages/admin/MediaLibrary';
import ServicesManager from './pages/admin/ServicesManager';
import GalleryManager from './pages/admin/GalleryManager';
import RentalsManager from './pages/admin/RentalsManager';
import PackagesManager from './pages/admin/PackagesManager';
import TestimonialsManager from './pages/admin/TestimonialsManager';
import HeroManager from './pages/admin/HeroManager';

import './i18n';
import './App.css';

const Home = () => {
  usePageTracking();
  
  return (
    <div className="min-h-screen">
      <SEO />
      <SchemaOrg />
      <Header />
      <Hero />
      <Services />
      <Gallery />
      <Rentals />
      <Testimonials />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* New Admin Dashboard with nested routes */}
            <Route 
              path="/admin/*" 
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="services" element={<ServicesManager />} />
              <Route path="gallery" element={<GalleryManager />} />
              <Route path="rentals" element={<RentalsManager />} />
              <Route path="packages" element={<PackagesManager />} />
              <Route path="testimonials" element={<TestimonialsManager />} />
              <Route path="hero" element={<HeroManager />} />
              <Route path="quotes" element={<AdminDashboard />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
